import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class NavPopupService {
  private _isOpen$ = new BehaviorSubject<boolean>(false)

  get isOpen$(): Observable<boolean> {
    return this._isOpen$.asObservable()
  }

  get isOpen(): boolean {
    return this._isOpen$.value
  }

  open(): void {
    this._isOpen$.next(true)
  }

  close(): void {
    this._isOpen$.next(false)
  }

  toggle(): void {
    this._isOpen$.next(!this._isOpen$.value)
  }
}
